module.exports = __webpack_public_path__ + "img/TCC-L1-Pagina1 A.f4946b94.png";